export class TrialService {
  private static BASE_URL = "/api";

  static async trialUserSignup(email: string, language: string) {
    const res = await fetch(`${this.BASE_URL}/trial`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ email, language })
    });

    return res.json();
  }
}
